var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    apikeys: [],
    apiKeyToCopy: '',
    searchString: '',
}); };
function apikeyStateReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_APIKEY_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_APIKEY_SUCCESS':
                state.loading = false;
                state.error = false;
                state.apikeys = action.apikeys || [];
                break;
            case 'LOAD_APIKEY_FAILURE':
                state.loading = false;
                state.error = true;
                state.apikeys = [];
                break;
            case 'CREATE_APIKEY_ITEM_REQUEST':
            case 'UPDATE_APIKEY_ITEM_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'CREATE_APIKEY_ITEM_SUCCESS':
                state.loading = false;
                state.error = false;
                state.apikeys = __spreadArray(__spreadArray([], (state.apikeys || []), true), [action.apikeyObject], false);
                state.apiKeyToCopy = action.apikeyObject.meta.apiKey;
                break;
            case 'UPDATE_APIKEY_ITEM_SUCCESS':
                state.loading = false;
                state.error = false;
                var index = state.apikeys.findIndex(function (item) { return item.id === action.apikeyObject.id; });
                var newApiKeys = cloneDeep(state.apikeys);
                newApiKeys[index] = action.apikeyObject;
                state.apikeys = newApiKeys || [];
                break;
            case 'CREATE_APIKEY_ITEM_FAILURE':
            case 'UPDATE_APIKEY_ITEM_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_APIKEY_ITEM_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_APIKEY_ITEM_SUCCESS':
                state.loading = false;
                state.error = false;
                state.apikeys = state.apikeys.filter(function (l) { return l.id !== action.apikeyId; });
                break;
            case 'DELETE_APIKEY_ITEM_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'SEARCH_APIKEY_REQUEST':
                state.searchString = action.searchString || '';
                break;
            default:
                break;
        }
    });
}
export default apikeyStateReducer;
